import{mediaQueryLarge,requestIdleCallback,startViewTransition}from '@theme/utilities';import PaginatedList from '@theme/paginated-list';import{ThemeEvents}from '@theme/events';export default class ResultsList extends PaginatedList{#isLoading=!1;connectedCallback(){super.connectedCallback();mediaQueryLarge.addEventListener('change',this.#handleMediaQueryChange);this.setAttribute('initialized','');this.#setupFilterListeners();this.#addLoaderStyles()}
disconnectedCallback(){mediaQueryLarge.removeEventListener('change',this.#handleMediaQueryChange);this.#cleanup()}
updateLayout({target}){if(!(target instanceof HTMLInputElement))return;this.#showFullPageLoader();this.#animateLayoutChange(target.value)}
#animateLayoutChange=async(value)=>{const{grid}=this.refs;if(!grid){this.#hideFullPageLoader();return}
this.#setLayout(value);const viewport=mediaQueryLarge.matches?'desktop':'mobile';sessionStorage.setItem(`product-grid-view-${viewport}`,value);this.#hideFullPageLoader()};#setLayout(value){const{grid}=this.refs;if(!grid)return;grid.setAttribute('product-grid-view',value)}
#handleMediaQueryChange=(event)=>{const targetElement=event.matches?this.querySelector('[data-grid-layout="desktop-default-option"]'):this.querySelector('[data-grid-layout="mobile-option"]');if(!(targetElement instanceof HTMLInputElement))return;targetElement.checked=!0;this.#setLayout('default')};#setupFilterListeners(){document.addEventListener(ThemeEvents.FilterUpdate,this.#handleFilterUpdate)}
#handleFilterUpdate=(event)=>{this.#showFullPageLoader();this.#observeGridChanges()};#observeGridChanges(){const grid=document.querySelector('.product-grid');if(!grid){setTimeout(()=>this.#hideFullPageLoader(),3000);return}
const observer=new MutationObserver((mutations)=>{let hasContentChanges=!1;mutations.forEach((mutation)=>{if(mutation.type==='childList'&&mutation.addedNodes.length>0){hasContentChanges=!0}});if(hasContentChanges){observer.disconnect();setTimeout(()=>{this.#hideFullPageLoader()},300)}});observer.observe(grid,{childList:!0,subtree:!0});setTimeout(()=>{observer.disconnect();this.#hideFullPageLoader()},5000)}
#showFullPageLoader(){if(this.#isLoading)return;this.#isLoading=!0;const loader=document.createElement('div');loader.id='full-page-loader';loader.innerHTML=`
      <div class="loader-backdrop">
        <div class="loader-content">
          <div class="loader-spinner">
            <svg width="50" height="50" viewBox="0 0 50 50">
              <circle cx="25" cy="25" r="20" stroke="#e5e5e5" stroke-width="4" fill="none"/>
              <circle cx="25" cy="25" r="20" stroke="#666" stroke-width="4" fill="none"
                      stroke-dasharray="125.6" stroke-dashoffset="125.6"
                      class="loader-circle">
              </circle>
            </svg>
          </div>
        </div>
      </div>
    `;document.body.appendChild(loader);requestAnimationFrame(()=>{loader.classList.add('show')})}
#hideFullPageLoader(){if(!this.#isLoading)return;this.#isLoading=!1;const loader=document.getElementById('full-page-loader');if(loader){loader.classList.add('hide');setTimeout(()=>{if(loader.parentNode){loader.parentNode.removeChild(loader)}},400)}}
#addLoaderStyles(){if(document.getElementById('full-page-loader-styles'))return;const style=document.createElement('style');style.id='full-page-loader-styles';style.textContent=`
      #full-page-loader {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease, visibility 0.3s ease;
      }

      #full-page-loader.show {
        opacity: 1;
        visibility: visible;
      }

      #full-page-loader.hide {
        opacity: 0;
        visibility: hidden;
      }

      .loader-backdrop {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .loader-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

      }

      .loader-spinner {
        animation: spin 1s linear infinite;
      }

      .loader-circle {
        animation: dash 1.5s ease-in-out infinite;
      }

      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      @keyframes dash {
        0% { stroke-dashoffset: 125.6; }
        50% { stroke-dashoffset: 31.4; }
        100% { stroke-dashoffset: 125.6; }
      }
    `;document.head.appendChild(style)}
#cleanup(){document.removeEventListener(ThemeEvents.FilterUpdate,this.#handleFilterUpdate);const section=this.closest('.shopify-section');if(section){section.removeEventListener(ThemeEvents.FilterUpdate,this.#handleFilterUpdate)}
this.#hideFullPageLoader()}}
if(!customElements.get('results-list')){customElements.define('results-list',ResultsList)}